import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=9f34763e&scoped=true&"
import script from "./SettingsHeader.vue?vue&type=script&lang=js&"
export * from "./SettingsHeader.vue?vue&type=script&lang=js&"
import style0 from "./SettingsHeader.vue?vue&type=style&index=0&id=9f34763e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f34763e",
  null
  
)

export default component.exports